import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * @param {string[]} allowedRoles - e.g. ['admin'] or ['admin','author']
 * @param {boolean} requireActiveAuthor - when true, author must be status=active (admins always ok)
 */
const ProtectedRoute = ({ children, allowedRoles = ['admin'], requireActiveAuthor = true }) => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return <div className="login-container">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const roleAllowed = allowedRoles.includes(user.role) || (isAdmin && allowedRoles.includes('admin'));

  if (!roleAllowed) {
    return <Navigate to="/" replace />;
  }

  if (user.role === 'author' && requireActiveAuthor && user.status !== 'active') {
    return <Navigate to="/pending-approval" replace />;
  }

  if (user.role === 'admin' || (user.role === 'author' && (!requireActiveAuthor || user.status === 'active'))) {
    return children;
  }

  return <Navigate to="/" replace />;
};

export default ProtectedRoute;
